export default type => (payload = {}) => dispatch =>
  dispatch({
    type,
    payload,
  });
